'use client';

import { Slider } from '@shared/components/shadcn';
import { useEffect, useState } from 'react';

type RangeSliderLabelProps = {
  label: string;
  active: boolean;
};
function RangeSliderLabel({ label, active }: RangeSliderLabelProps) {
  return (
    <div className={`pl-6 first:pl-1 last:pr-1 last:pl-0 ${active ? 'paragraph-explanatory-strong text-foreground' : 'paragraph-explanatory text-foreground-subtle/87'}`}>
      {label}
    </div>
  );
}

type RangeSliderChangeEvent = {
  min: { label: string; value: number };
  max: { label: string; value: number };
};

type RangeSliderProps = {
  value?: number[];
  onValueChange: (value: { min: number; max: number }) => void;
  labels: string[];
};
function RangeSlider({ value, onValueChange, labels, ...props }: RangeSliderProps) {
  const [selectedRange, setSelectedRange] = useState<number[]>([1, labels.length]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setSelectedRange(value || [1, labels.length]);
  }, [value, labels]);

  const handleValueChange = (value: number[]) => {
    setSelectedRange(value);
    const changedValue: { min: number; max: number } = { min: value[0]!, max: value[1]! };
    onValueChange(changedValue);
  };
  return (
    <div className="flex flex-col pt-3" {...props}>
      <div className="flex flex-row justify-between">
        {labels.map(label => (
          <RangeSliderLabel key={label} label={label} active={selectedRange.includes(labels.indexOf(label) + 1)} />
        ))}
      </div>
      <div>
        <Slider className="py-7" value={selectedRange} min={1} max={labels.length} onValueChange={handleValueChange} />
      </div>
    </div>
  );
}

export { RangeSlider, type RangeSliderChangeEvent };
